import React, { useEffect, useState, useContext, useRef } from 'react'
import { ContentInner } from '../../../../../layout/Content'
import OutOfStockInnerStyle from './css/OutOfStockInnerStyle'
import { appContext } from '../../../../../../App'
import { outOfStockContext } from './OutOfStockController'
import { formatNumber } from '../../../../../utilities/utilities'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'

function ProductsListContents(props) {
  const products = props.products
  const classification = props.classification

  return (
    <React.Fragment>
      <div id='warehouse-inventory-container'>
        <table className='inventory-table'>
          <thead>
            <tr>
              <th style={{textAlign: 'left'}}>Item Name</th>
              <th style={{textAlign: 'left'}}>Unit</th>
              <th>Inventory</th>
              <th>Critical Level Quantity</th>
            </tr>
          </thead>
          {
            products.filter(product => (product.classification === classification)).map(product => (
              product.units.filter(unit => (unit.inventory <= unit.critical_level_quantity)).map((unit, index) => (
                <tbody key={index}>
                  <tr>
                    <td style={{textAlign: 'left'}}>{product.brand} {product.name} {product.description}</td>
                    <td>{unit.description}</td>
                    <td style={{textAlign: 'center'}}>{formatNumber(unit.inventory.toFixed(2))}</td>
                    <td style={{textAlign: 'center'}}>{formatNumber(unit.critical_level_quantity.toFixed(2))}</td>
                  </tr>
                </tbody>
              ))
            ))
          }
        </table>
      </div>
    </React.Fragment>
  )
}

function useOutOfStockInner(props) {
  const app = useContext(appContext)
  const outOfStockController = useContext(outOfStockContext)
  const { filter, getWarehouses, getProductsInventory } = outOfStockController
  const [productsInventory, setProductsInventory] = useState(null)
  const warehouseFilter = useRef([])
  const classificationFilter = useRef([])


  useEffect(() => {
    const initProductsInventory = async (warehouses) => {
      const prodInv = []

      for (let warehouse of warehouses) {
        // Filter the warehouse
        if (warehouseFilter.current.find(wh => (wh === warehouse.name))) {
          let products_list = await getProductsInventory(app, warehouse._id)

          // Filter the products
          products_list = products_list.filter(product => (
              classificationFilter.current.find(classification => (classification === product.classification))
            )
          )

          prodInv.push (
            {
              wh: warehouse,
              products: products_list
            }
          )

        }
      }
      setProductsInventory(prodInv)
    }

    const init = async () => {
      // Warehouse filter
      for (let key in filter.warehouse) {
        if (filter.warehouse[key]) {
          //push into temp array here
          warehouseFilter.current.push(key)
        }
      }

      // Classification filter
      for (let key in filter.classification) {
        if (filter.classification[key]) {
          classificationFilter.current.push(key)
        }
      }

      initProductsInventory(await getWarehouses(app))
    }

    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const obj = {
    app,
    productsInventory: [productsInventory, setProductsInventory],
    classifications: classificationFilter.current
  }

  return (obj)
}

function OutOfStockInner(props) {
  const outOfStockInner = useOutOfStockInner(props)
  const { app } = outOfStockInner
  const productsInventory = outOfStockInner.productsInventory[0]
  const classifications = outOfStockInner.classifications

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div id='products-list-container' className='printable'>
          {
            (productsInventory) ?
              productsInventory.map((pi, i) => (
                <div key={i} className={ (i === 0) ? 'firstpage' : 'pagebreak' }>
                  <div className='products-inventory-header-container'>
                    <div className='products-inventory-header'>Out Of Stock Items</div>
                    <div className='products-inventory-date'>As of {new Date(app.getClientDateTime()).toLocaleString("en-us")} { app.getClientTimezone() }</div>
                  </div>
                  <br />
                  <div className='warehouse-name'><span style={{fontWeight: 'bold'}}>Warehouse:</span> {pi.wh.name} </div>
                  <hr />
                  {
                    classifications.map((classification, index) => (
                      <div key={index}>
                        <div><b>Classification:</b> {classification}</div>
                        <div className='products-list-contents-wrapper'>
                          <ProductsListContents products={pi.products} classification={classification}/>
                        </div>
                      </div>
                    ))
                  }
                </div>
              ))
            : null
          }
        </div>
      </div>
      <OutOfStockInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(OutOfStockInner)